<ng-container *ngIf="!useAlternate; else staticBackup">
  <div class="animation-container">
    <h1 class="good-job-text">{{ message }}</h1>
    <canvas class="animation-canvas" riv="reflection-complete" [height]="canvasHeight" [width]="canvasWidth">
      <riv-player name="Untitled" mode="one-shot" [play]="playAnimation" (playChange)="playChange()"></riv-player>
    </canvas>
  </div>
</ng-container>

<ng-template #staticBackup>
  <div class="fallback-animation">
    <div class="diamond one"></div>
    <div class="diamond two"></div>
    <div class="diamond three"></div>
    <div class="diamond four"></div>
    <h1 class="animation-message">{{ message }}</h1>
    <div class="diamond five"></div>
    <div class="diamond six"></div>
    <div class="diamond seven"></div>
    <div class="diamond eight"></div>
  </div>
</ng-template>
